// extracted by mini-css-extract-plugin
export default {"template":"RoomPage_template__-H6lL","title":"RoomPage_title__lqZmT","content":"RoomPage_content__FrLgH","map":"RoomPage_map__bkVxG"};